// extracted by mini-css-extract-plugin
module.exports = {"image":"dynamo-image_image__FFB0B","image--auto-width":"dynamo-image_image--auto-width__kssH3"};